import Splide from '@splidejs/splide';

export const initCaseStudiesGalleryCarousel = () => {
  const gallerySliderEl = document.querySelector(
    '[data-pro-builder-case-studies-template-gallery-slider]'
  );

  if (gallerySliderEl) {
    const gallerySlider = new Splide(gallerySliderEl, {
      type: 'loop',
      perPage: 1,
      perMove: 1,
      speed: 500,
      rewind: true,
      arrows: true,
      pagination: false,
    });

    gallerySlider.mount();
  }
};
